import { gridSize } from '@atlaskit/theme';

export const defaultOptions = {
  automaticLayout: true,
  contextmenu: false,
  // This is akCodeFontFamily with 'courier' chopped out of the middle for sane
  // defaults in the case of missing fonts
  fontFamily:
    "ui-monospace, 'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, monospace",
  fontSize: 13,
  hideCursorInOverviewRuler: true,
  hover: false,
  lineDecorationsWidth: gridSize(),
  // the gutter only really fits N-1 characters due to `lineDecorationsWidth`
  lineNumbersMinChars: 6,
  matchBrackets: false,
  minimap: { enabled: false },
  occurrencesHighlight: false,
  // required even though the docs say it defaults to `false`
  renderIndentGuides: false,
  renderLineHighlight: 'none',
  scrollBeyondLastLine: false,
  selectionHighlight: false,
  // we handle this ourselves
  selectOnLineNumbers: false,
};

export const editorOptions = {
  readOnly: false,
};

export const readOnlyOptions = {
  readOnly: true,
};
